class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Globally attach hover-to-open logic for all header dropdown menus on desktop
document.addEventListener('DOMContentLoaded', () => {
  const setupHoverMenus = () => {
    // Only apply on desktop breakpoints
    if (window.matchMedia('(min-width: 990px)').matches) {
      // Modify query selector to ONLY target top-level header menus, ignoring nested submenus
      document.querySelectorAll('header-menu > details').forEach(details => {
        if (details.dataset.hoverAttached) return;
        details.dataset.hoverAttached = 'true';
        
        let hoverTimeout;
        
        details.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout);
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
            const summary = details.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', 'true');
          }
        });
        
        details.addEventListener('mouseleave', () => {
          hoverTimeout = setTimeout(() => {
            if (details.hasAttribute('open')) {
              details.removeAttribute('open');
              const summary = details.querySelector('summary');
              if (summary) summary.setAttribute('aria-expanded', 'false');
            }
          }, 150); // Small grace period makes the menu smooth to navigate
        });
      });
    }
  };

  setupHoverMenus();
});
